interface DefaultsToggleProps {
  on: boolean;
  onToggle: () => void;
}

/**
 * Toggle for an SC2 setup: a `.SC2Hotkeys` source is a delta, so Keylens fills the untouched keys
 * from the Blizzard Standard table to show the real in-game layout. `on` hides those filled-in
 * defaults, leaving only what this setup itself binds. A two-label text pill in the SC2 view-options
 * group beside Rapid-fire. ON (the filtered view) reads "My keys only" and fills ember, so engaged
 * ember consistently means "a filter is active" - matching the other toggles.
 */
export function DefaultsToggle({ on, onToggle }: DefaultsToggleProps) {
  // on === hideDefaults: ON shows only this setup's own keys, OFF shows all (incl. Standard defaults)
  const label = on ? "My keys only" : "All keys";
  const title = on ? "Showing only this setup's keys" : "Showing Standard-filled keys";
  return (
    <button
      type="button"
      className={on ? "defaults-toggle on" : "defaults-toggle"}
      onClick={onToggle}
      aria-pressed={on}
      title={title}
    >
      {label}
    </button>
  );
}
